import { useCurrentUserInfo } from './useCurrentUserInfo';
import { useGoToPath } from './useGoToPath';
import { APP_PATH_USER_TYPE_SELECTION, APP_PATH_CANDIDATE_PROFILE } from '../config';
import { useEffect } from 'react';

export const useRedirectLoggedUserToDashboard = () => {
  const { isLogin, user } = useCurrentUserInfo();
  const isCandidate = user?.roles?.includes('ROLE_CANDIDATE');
  const redirectPath = isCandidate ? APP_PATH_CANDIDATE_PROFILE : APP_PATH_USER_TYPE_SELECTION;
  const { handleGoToPath } = useGoToPath(redirectPath);
  useEffect(() => {
    if (isLogin) {
      handleGoToPath();
    }
  }, [isLogin, handleGoToPath]);
  return {};
};
